import { useState, useEffect } from "react"
import Modal from '../comun/VentanaModal.jsx'
import { getCombos, getCantidad } from '../componentes/api.js';
import { Alert, Stack } from '@mui/material';
import LineAxisIcon from '@mui/icons-material/LineAxis';
import { Card } from 'react-bootstrap';

const Analitica =()=>{
  const [idProyecto, setIdProyecto] = useState('')
  const [proyectos, setProyectos] = useState([]);
  const [numActividades, setNumActividades] = useState(0)
  const [numCaracterizaciones, setNumCaracterizaciones] = useState(0)
  const [vrTotal, setVrTotal] = useState(numActividades + numCaracterizaciones)
  
  const [numActividadesA, setNumActividadesA] = useState(0)
  const [numCaracterizacionesA, setNumCaracterizacionesA] = useState(0)
  const [vrTotalA, setVrTotalA] = useState(numActividadesA + numCaracterizacionesA)
  

  /** Para el manejo de la ventana de mensajes modal**/
  const [show, setShow] = useState(false);
  const [msg, setMsg] = useState([]);
  const handleClose = () => setShow(false);

  const calcularProyecto=async(event)=>{
    event.preventDefault();
    if(idProyecto===''){
      mostrarMsg(["Por favor seleccione un Proyecto"]);
    }else{
      calcularDatos("ficha_caracterizacion", "IdProyecto='" + idProyecto + "'", 'numCaracterizaciones')
      calcularDatos("proyecto_actividad", "Proyecto='" + idProyecto + "'", 'numActividades')

      calcularDatos("ficha_caracterizacion", "IdProyecto='" + idProyecto + "' AND Aprovada=1", 'numCaracterizacionesA')
      calcularDatos("proyecto_actividad_desarrollo", "Proyecto='" + idProyecto + "'", 'numActividadesA')

      setVrTotal(numCaracterizaciones + numActividades)
      setVrTotalA(numCaracterizacionesA + numActividadesA)
    }

  }


  const calcularDatos=async(tabla, sql, llamador)=>{
    try {
      const response = await getCantidad({tabla:tabla, sql:sql})
      if(llamador==='numCaracterizaciones'){
        setNumCaracterizaciones(response.data[0].Cant)
        setVrTotal(numActividades + response.data[0].Cant)

      }else if(llamador==='numActividades'){
        setNumActividades(response.data[0].Cant)
        setVrTotal(response.data[0].Cant + numCaracterizaciones)

      }else if(llamador==='numCaracterizacionesA'){
        setNumCaracterizacionesA(response.data[0].Cant)
        setVrTotalA(numActividadesA + response.data[0].Cant)

      }else if(llamador==='numActividadesA'){
        setNumActividadesA(response.data[0].Cant)
        setVrTotalA(response.data[0].Cant + numCaracterizacionesA)

      }
              
    } catch (error) {
      mostrarMsg(["ERROR", "Ocurrio un error al consultar los datos!", error])
    }
  }

  const cargarProyectos= async()=>{
    try {
      const response = await getCombos({"Tabla":"proyectos","Campo":""},"cboProyectos")
      setProyectos(response.data)
    } catch (error) {
      mostrarMsg(["ERROR", "Ocurrio un error al cargar los Proyectos", error])
    }
  }

  const mostrarMsg = (msg)=>{
    setMsg(msg)
    setShow(true)
  }

  useEffect(() =>{
    cargarProyectos();
    
  },[]);

  return(
    <div className="container">
      <div className="row mt-3 mb-3">
        <Stack sx={{ width: '100%' }} spacing={2}>
          <Alert severity="success"><strong>Menu de Analitica</strong></Alert>
        </Stack>
      </div>

      <div className="row">
        <div className="form-floating mb-2 mt-2">
          <select
            type="text" 
            className="form-control" 
            name='idProyecto' 
            value={idProyecto} 
            onChange={(event) =>{setIdProyecto(event.target.value);}}
          >
            <option key='0' value='0'>Por favor seleccione un Proyecto...</option>
            {proyectos.map((reg) => {
              return (
                <option key={reg.Id} value={reg.Id} label={reg.Nbre}> {reg.Nbre} </option>
              );
            })}
          </select>
          <label htmlFor="idProyecto">Proyecto Actual</label>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-4">
          <Card style={{ width: '30rem' }}>
            <Card.Body>
              <Card.Title className="mb-2 text-muted">Avance del Proyecto</Card.Title>
              <div className="row">
                <div className="col-sm-4">
                  <Card.Text className="mb-2 text-muted">Concepto</Card.Text>
                  <Card.Subtitle className="mb-2">Caracterizaciones:</Card.Subtitle>
                  <Card.Subtitle className="mb-2">Actividades:</Card.Subtitle>
                  <Card.Subtitle className="mb-2">Total:</Card.Subtitle>
                </div>

                <div className="col-sm-3">
                <Card.Text className="mb-2 text-muted">Registradas</Card.Text>
                  <Card.Subtitle className="mb-2"> {numCaracterizaciones}</Card.Subtitle>
                  <Card.Subtitle className="mb-2"> {numActividades}</Card.Subtitle>
                  <Card.Subtitle className="mb-2"> {vrTotal}</Card.Subtitle>

                </div>
                <div className="col-sm-3">
                  <Card.Text className="mb-2 text-muted">Aprovadas</Card.Text>
                  <Card.Subtitle className="mb-2"> {numCaracterizacionesA}</Card.Subtitle>
                  <Card.Subtitle className="mb-2"> {numActividadesA}</Card.Subtitle>
                  <Card.Subtitle className="mb-2"> {vrTotalA}</Card.Subtitle>
                </div>
                <div className="col-sm-2">
                  <Card.Text className="mb-2 text-muted">%</Card.Text>
                  <Card.Subtitle className="mb-2"> {parseInt((numCaracterizacionesA * 100)/numCaracterizaciones)}%</Card.Subtitle>
                  <Card.Subtitle className="mb-2"> {parseInt((numActividadesA * 100)/ numActividades)}%</Card.Subtitle>
                  <Card.Subtitle className="mb-2"> {parseInt((vrTotalA * 100)/ vrTotal)}%</Card.Subtitle>
                </div>
              </div>
              
              <Card.Link href="#" onClick={(event) => calcularProyecto(event)}><LineAxisIcon />Calcular</Card.Link>
            </Card.Body>
          </Card>
        </div>
      </div>

      <Modal show={show} handleClose={handleClose} msg={msg} />

    </div>
    )
}

export default Analitica